import { injectStyle } from "./../../../../utils/style";
import { h } from "./../../../../utils/createElement";
import { __extends } from "tslib";
import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import dayjs from '../dayjs';
injectStyle("components/DatePicker/rc-calendar/style/common/DecadePanel.css", "[data-dui-0-122-5~=\"dui-calendar-decade-panel\"]{position:absolute;z-index:10;top:0;right:0;bottom:0;left:0;display:-webkit-box;display:-webkit-flex;display:-ms-flexbox;display:flex;-webkit-box-orient:vertical;-webkit-box-direction:normal;-webkit-flex-direction:column;-ms-flex-direction:column;flex-direction:column;background:#fff}[data-dui-0-122-5~=\"dui-calendar-decade-panel-hidden\"]{display:none}[data-dui-0-122-5~=\"dui-calendar-decade-panel-header\"]{position:relative;height:66px;padding:0 10px;font-size:16px;line-height:66px;text-align:center}[data-dui-0-122-5~=\"dui-calendar-decade-panel-header\"]>a{display:inline-block;cursor:pointer;font-weight:500;text-align:center}[data-dui-0-122-5~=\"dui-calendar-decade-panel-header\"]>a:hover{color:#175ceb}[data-dui-0-122-5~=\"dui-calendar-decade-panel-next-century-btn\"],[data-dui-0-122-5~=\"dui-calendar-decade-panel-prev-century-btn\"]{position:absolute;top:0;bottom:0;margin:auto 0}[data-dui-0-122-5~=\"dui-calendar-decade-panel-next-century-btn\"]:hover,[data-dui-0-122-5~=\"dui-calendar-decade-panel-prev-century-btn\"]:hover{background-color:#e9ebed}[data-dui-0-122-5~=\"dui-calendar-decade-panel-prev-century-btn\"]{left:25px;width:16px;height:16px;background:url(../img/arrow_double@2x.png) no-repeat 50%/contain;-webkit-transform:rotate(180deg);transform:rotate(180deg)}[data-dui-0-122-5~=\"dui-calendar-decade-panel-next-century-btn\"]{right:25px;width:16px;height:16px;background:url(../img/arrow_double@2x.png) no-repeat 50%/contain}[data-dui-0-122-5~=\"dui-calendar-decade-panel-body\"]{position:absolute;top:34px;bottom:0;padding:9px 10px 10px}[data-dui-0-122-5~=\"dui-calendar-decade-panel-footer\"]{border-top:1px solid #c2c2c2;line-height:38px}[data-dui-0-122-5~=\"dui-calendar-decade-panel-table\"]{width:100%;height:100%;border-collapse:separate;table-layout:fixed}[data-dui-0-122-5~=\"dui-calendar-decade-panel-cell\"]{text-align:center}[data-dui-0-122-5~=\"dui-calendar-decade-panel-decade\"]{display:block;height:36px;padding:0;margin:0 auto;background:transparent;border-radius:4px;color:var(--text-ultrastrong,rgba(0,0,0,.88));cursor:pointer;line-height:36px;text-align:center}[data-dui-0-122-5~=\"dui-calendar-decade-panel-decade\"]:hover{background:rgba(0,0,0,.04)}[data-dui-0-122-5~=\"dui-calendar-decade-panel-selected-cell\"] [data-dui-0-122-5~=\"dui-calendar-decade-panel-decade\"],[data-dui-0-122-5~=\"dui-calendar-decade-panel-selected-cell\"] [data-dui-0-122-5~=\"dui-calendar-decade-panel-decade\"]:hover{background:#1e6fff;color:#fff}[data-dui-0-122-5~=\"dui-calendar-decade-panel-last-century-cell\"] [data-dui-0-122-5~=\"dui-calendar-decade-panel-decade\"],[data-dui-0-122-5~=\"dui-calendar-decade-panel-next-century-cell\"] [data-dui-0-122-5~=\"dui-calendar-decade-panel-decade\"]{color:var(--text-weak,rgba(0,0,0,.24))}");
var emptyFn = function () { };
var ROW = 4;
var COL = 3;
var DecadePanel = (function (_super) {
    __extends(DecadePanel, _super);
    function DecadePanel(props) {
        var _this = _super.call(this, props) || this;
        _this.state = {
            value: props.value || props.defaultValue,
        };
        _this.prefixCls = props.rootPrefixCls + "-decade-panel";
        _this.nextCentury = _this.goYear.bind(_this, 100);
        _this.previousCentury = _this.goYear.bind(_this, -100);
        return _this;
    }
    Object.defineProperty(DecadePanel.prototype, "currentYear", {
        get: function () {
            var value = this.state.value;
            return value.year();
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(DecadePanel.prototype, "endYear", {
        get: function () {
            return this.startYear + 99;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(DecadePanel.prototype, "startYear", {
        get: function () {
            return parseInt(this.currentYear / 100, 10) * 100;
        },
        enumerable: false,
        configurable: true
    });
    DecadePanel.prototype.goYear = function (direction) {
        var next = this.state.value.clone();
        next.add(direction, 'years');
        this.setState({
            value: next,
        });
    };
    DecadePanel.prototype.chooseDecade = function (year, event) {
        var next = this.state.value.clone();
        next.year(year);
        next.month(this.state.value.month());
        this.props.onSelect(next);
        event.preventDefault();
    };
    DecadePanel.prototype.renderHeader = function () {
        var _a = this, prefixCls = _a.prefixCls, startYear = _a.startYear, endYear = _a.endYear;
        var locale = this.props.locale;
        return (h("div", { className: prefixCls + "-header" },
            h("span", { className: prefixCls + "-prev-century-btn", role: "button", tabIndex: "0", title: locale.previousCentury, onClick: this.previousCentury, onKeyDown: emptyFn }),
            h("div", { className: prefixCls + "-century" },
                startYear,
                "-",
                endYear),
            h("span", { className: prefixCls + "-next-century-btn", role: "button", tabIndex: "0", title: locale.nextCentury, onClick: this.nextCentury, onKeyDown: emptyFn })));
    };
    DecadePanel.prototype.renderBody = function () {
        var _this = this;
        var _a = this, currentYear = _a.currentYear, endYear = _a.endYear, prefixCls = _a.prefixCls, startYear = _a.startYear;
        var preYear = startYear - 10;
        var index = 0;
        var decades = Array.from({ length: ROW }).reduce(function (rowMemo) {
            var colArr = Array.from({ length: COL }).reduce(function (colMemo) {
                var startDecade = preYear + index * 10;
                var endDecade = startDecade + 9;
                index += 1;
                return colMemo.concat({
                    startDecade: startDecade,
                    endDecade: endDecade,
                });
            }, Array.from({}));
            return rowMemo.concat([colArr]);
        }, Array.from({}));
        var decadesEls = decades.map(function (row, decadeIndex) {
            var tds = row.map(function (decadeData) {
                var _a;
                var dStartDecade = decadeData.startDecade;
                var dEndDecade = decadeData.endDecade;
                var isLast = dStartDecade < startYear;
                var isNext = dEndDecade > endYear;
                var classNameMap = (_a = {},
                    _a[prefixCls + "-selected-cell"] = dStartDecade <= currentYear && currentYear <= dEndDecade,
                    _a[prefixCls + "-last-century-cell"] = isLast,
                    _a[prefixCls + "-next-century-cell"] = isNext,
                    _a);
                var content = dStartDecade + "-" + dEndDecade;
                var clickHandler;
                if (isLast) {
                    clickHandler = _this.previousCentury;
                }
                else if (isNext) {
                    clickHandler = _this.nextCentury;
                }
                else {
                    clickHandler = _this.chooseDecade.bind(_this, dStartDecade);
                }
                return (h("td", { key: dStartDecade, className: classnames(prefixCls + "-cell", classNameMap), role: "gridcell", onClick: clickHandler },
                    h("span", { className: prefixCls + "-decade" }, content)));
            });
            return h("tr", { key: Number(decadeIndex), role: "row" }, tds);
        });
        return (h("div", { className: prefixCls + "-body" },
            h("table", { cellSpacing: "0", className: prefixCls + "-table", role: "grid" },
                h("tbody", { className: prefixCls + "-tbody" }, decadesEls))));
    };
    DecadePanel.prototype.renderFooter = function () {
        var prefixCls = this.prefixCls;
        var renderFooter = this.props.renderFooter;
        var footer = renderFooter === null || renderFooter === void 0 ? void 0 : renderFooter('decade');
        return footer ? (h("div", { className: prefixCls + "-footer" }, footer)) : null;
    };
    DecadePanel.prototype.render = function () {
        return (h("div", { className: this.prefixCls },
            this.renderHeader(),
            this.renderBody(),
            this.renderFooter()));
    };
    return DecadePanel;
}(React.Component));
export default DecadePanel;
DecadePanel.propTypes = {
    defaultValue: PropTypes.instanceOf(dayjs),
    locale: PropTypes.shape({
        nextCentury: PropTypes.string,
        previousCentury: PropTypes.string,
    }),
    renderFooter: PropTypes.func,
    rootPrefixCls: PropTypes.string,
    value: PropTypes.instanceOf(dayjs),
};
DecadePanel.defaultProps = {
    defaultValue: undefined,
    locale: {},
    renderFooter: undefined,
    rootPrefixCls: '',
    value: undefined,
};
